import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حساب كثافة الماء  - حاسبة كثافة المياه";
const DESCRIPTION =
  "استخدم حاسبة كثافة الماء لحساب كثافة الماء أو أي مادة أخرى بسهولة باستخدام المعادلة: الكثافة = كتلة المادة / حجم المادة. تعلم كيفية تحويل وحدات الكثافة وفهم مفهوم الكثافة.";
const KEYWORDS =
  "حاسبة كثافة الماء, كثافة المواد, حساب الكثافة, كتلة المادة, حجم المادة, الجرام/سم3, الكجم/م3, فيزياء, قوانين الكثافة";
const OG_URL =
  "https://do-calculate.com/calculator/ar/water-density-calculator/";
function WaterDensityCalculator() {
  const [mass, setMass] = useState(0);
  const [volume, setVolume] = useState(0);
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (mass && volume) {
        const density = parseFloat(mass) / parseFloat(volume);
        setResult(density);
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تقوم هذه الحاسبة بحساب كثافة الماء أو أي مادة أخرى باستخدام
                  المعادلة التالية:
                </p>
                <p>
                  <strong>الكثافة = كتلة المادة / حجم المادة</strong>
                </p>
                <ul>
                  <li>
                    ادخل كتلة المادة وحجمها لحساب الكثافة بوحدة الجرام/سم3 أو
                    الكجم/م3.
                  </li>
                  <li>
                    كثافة الماء عند درجة حرارة 4 درجات مئوية تساوي 1 جرام/سم3 أو
                    1000 كجم/م3.
                  </li>
                </ul>
                <p>
                  تم تطوير هذه الحاسبة لتسهيل عملية حساب الكثافة وفهم العلاقة
                  بين الكتلة والحجم لأي مادة.
                </p>
                <hr />
              </div>
              <br />
            </div>
               <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="mass">
                      <label className="form-label ms-2">
                        ادخل كتلة المادة (جرام)
                      </label>
                      <input
                        id="mass"
                        type="number"
                        value={mass}
                        onChange={(e) => setMass(e.target.value)}
                        placeholder="أدخل كتلة المادة"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="volume">
                      <label className="form-label ms-2">
                        ادخل حجم المادة (سم3)
                      </label>
                      <input
                        id="volume"
                        type="number"
                        value={volume}
                        onChange={(e) => setVolume(e.target.value)}
                        placeholder="أدخل حجم المادة"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className="text-white">النتيجة:</h4>
                      <p className="text-white">{result} جرام/سم3</p>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <h4 style={{ color: "black" }}>خطوات الحل:</h4>
                        <ol>
                          <li>
                            حساب الكثافة باستخدام المعادلة: الكثافة = الكتلة /
                            الحجم
                          </li>
                          <li>
                            الكثافة = {mass} جرام / {volume} سم3 = {result}{" "}
                            جرام/سم3
                          </li>
                        </ol>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">ما هي الكثافة؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مفهوم الكثافة</h2>
                  </u>
                  <p>
                    الكثافة هي مقدار كتلة وحدة الحجوم من مادة معينة، وتُحسب
                    بالقانون التالي:
                  </p>
                  <ul>
                    <li>
                      <strong>الكثافة = الكتلة / الحجم</strong>
                    </li>
                    <li>تُعبر عن الكثافة بوحدات مثل جرام/سم3 أو كجم/م3.</li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: كثافة الماء تساوي 1 جرام/سم3 عند درجة حرارة 4 درجات
                    مئوية.
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>كيف نحسب كثافة المواد؟</h2>
                  </u>
                  <p>يمكن حساب كثافة أي مادة باستخدام المعادلة:</p>
                  <ul>
                    <li>
                      ادخل كتلة المادة وحجمها في الحاسبة لتحصل على الكثافة.
                    </li>
                    <li>احرص على استخدام وحدات متسقة عند إدخال القيم.</li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: إذا كانت كتلة مادة 500 جرام وحجمها 250 سم3، فإن
                    كثافتها تساوي 2 جرام/سم3.
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default WaterDensityCalculator;
